import { Select, createStyles, rem } from "@mantine/core";
import { useEffect, useState } from "react";
import { FiChevronLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import styled from "styled-components";
import { Unit } from "../../entities/unit";
import { BiService } from "../../services/bi/bi.service";
import { Lesson, LessonService } from "../../services/lesson/lesson.service";
import { UnitService } from "../../services/unit/unit.service";
import { Chart, ChartPanel, FiltersPanel, PageContent, PageHeader, PageWrapper } from "./styles";

const useStyles = createStyles((theme) => ({
  root: { position: "relative", marginBottom: rem(2.4) },
  input: { height: rem(56), paddingTop: rem(18) },
  label: {
    position: "absolute",
    pointerEvents: "none",
    fontSize: theme.fontSizes.xs,
    paddingLeft: theme.spacing.sm,
    paddingTop: `calc(${theme.spacing.sm} / 2)`,
    zIndex: 1,
  },
}));

export function Classes() {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const [unitites, setUnities] = useState<Unit[]>(new Array<Unit>());
  const [lessons, setLessons] = useState<Lesson[]>(new Array<Lesson>());
  const [lessonsSelected, setLessonsSelected] = useState<string | null>(null);
  const [data, setData] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const option = {
    title: { text: "Percentual de membros presentes", left: "center" },
    legend: { top: "bottom" },
    toolbox: { feature: { saveAsImage: { title: "Salvar imagem" } } },
    series: [
      {
        type: "pie",
        radius: [50, 180],
        center: ["50%", "50%"],
        roseType: "area",
        itemStyle: { borderRadius: 8 },
        data,
      },
    ],
  };

  const fetch = async (): Promise<void> => {
    try {
      setIsLoading(true);
      const [response, responseLesson] = await Promise.all([UnitService.get(), LessonService.getAtDate()]);
      setUnities(response);
      setLessons(responseLesson);
    } catch (error: any) {
      toast.warning(error[0], { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchData = async (): Promise<void> => {
    setIsLoading(true);
    try {
      if (lessonsSelected) {
        const [anoS, trimestreS, licaoS] = lessonsSelected.split(";");
        const year = Number(anoS.replace(/[^0-9]/g, ""));
        const quarter = Number(trimestreS.replace(/[^0-9]/g, ""));
        const number = Number(licaoS.replace(/[^0-9]/g, ""));

        const response = await BiService.getPresentMissingRelation({ number, quarter, year, unit_ids: [] });

        if (!response?.items?.length) {
          toast.warning("Não há dados para serem exibidos", { position: toast.POSITION.TOP_RIGHT });
          setData([]);
          return;
        }

        const unidades: any[] = [];
        response.items.forEach((r) => {
          const value = r.result.find((k) => k.key === "Percentual de presença")?.value;
          unidades.push({ value, name: `${r.label} - ${value?.toFixed(2)}%` });
        });
        setData(unidades.sort((a: any, b: any) => b.value - a.value));
      }
    } catch (error: any) {
      toast.warning(error[0], { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetch(); }, []);

  return (
    <PageWrapper>
      <PageHeader onClick={() => navigate(-1)}>
        <FiChevronLeft />
        <span>Percentual de membros presentes</span>
      </PageHeader>

      <PageContent>
        <FiltersPanel>
          <Select
            mt="md"
            withinPortal
            data={lessons.map((l) => `Ano: ${l.year}; Trimestre: ${l.quarter}; Lição: ${l.number}`)}
            placeholder="Selecione uma lição"
            label="Lição"
            classNames={classes}
            onChange={setLessonsSelected}
          />
          <SearchButton onClick={fetchData} disabled={isLoading}>
            {isLoading ? <Spinner color="light" style={{ width: 18, height: 18 }} /> : <label style={{ cursor: "pointer" }}>Buscar</label>}
          </SearchButton>
        </FiltersPanel>

        <ChartPanel>
          <Chart option={option} />
        </ChartPanel>
      </PageContent>
    </PageWrapper>
  );
}

const SearchButton = styled.button`
  height: 3.5rem;
  border-radius: 0.4rem;
  background-color: #3439a5;
  border: 0.1rem solid #2b2fa3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.8rem;

  label {
    color: #fff;
    font-size: 1.4rem;
    font-weight: bold;
  }

  &:disabled { opacity: 0.6; }
`;
